import React, {useState, Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {
  Form,
} from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
// import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import NewOpenIssuesVendorDashboard from "./InsidePages/NewOpenIssuesVendorDashboard";
import InProcessOpenIssuesVendorDashboard from "./InsidePages/InProcessOpenIssuesVendorDashboard";
import ClosedOpenIssuesVendorDashboard from "./InsidePages/ClosedOpenIssuesVendorDashboard";
import AllOpenIssuesVendorDashboard from "./InsidePages/AllOpenIssuesVendorDashboard";
import { Button, Col } from "react-bootstrap";
import Filter from "./Filter";
import AddOpenIssuesVendor from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/InsideAllPageComponent/AddOpenIssuesVendor";
import Media from "react-media";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

export class OpenIssuesVendor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      search: "",
      isActive:false,
    };
  }

  pageChangeButtonHandler = (value) => {
    this.setState({
      selectedTab: value,
    });
  };

  //const [isActive, setActive] = useState(false);
  setActive = () => {
    this.setState({isActive:!this.state.isActive})
  }

  onChangeSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>

            {/* <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div> */}
            <div className="right-side-panel container-fluid">
              <RightSideNavigation
                // leftText="vendorReview"
                // backButtonLink="/seatingdashboard"
                // displayText="Open User Tickets"
                displayButton="addOpenIssuesUsers"
              />
              <div className="main-seating-dashboard-body">
                <Media query="(min-width: 992px)">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">
                      Open User Tickets
                    </div>
                    <AddOpenIssuesVendor />
                  </div>
                </Media>
                <div className="d-flex flex-wrap align-items-center navigation-top-openissues">
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      this.state.selectedTab === 1 ? "active" : ""
                    }`}
                    onClick={() => this.pageChangeButtonHandler(1)}
                  >
                    New
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      this.state.selectedTab === 2 ? "active" : ""
                    }`}
                    onClick={() => this.pageChangeButtonHandler(2)}
                  >
                    In-Process
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      this.state.selectedTab === 3 ? "active" : ""
                    }`}
                    onClick={() => this.pageChangeButtonHandler(3)}
                  >
                    Closed
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      this.state.selectedTab === 4 ? "active" : ""
                    }`}
                    onClick={() => this.pageChangeButtonHandler(4)}
                  >
                    All
                  </Button>
                </div>{" "}
                <Media query="(max-width: 991px)">
                  <div className="w-100">
                    <hr />
                  </div>
                </Media>
                <Row className="align-items-center d-pt-4">
                  <Col className="col-auto seating-topbar-search px-0">
                    <div className="filter-button">
                      <Filter />
                    </div>
                  </Col>
                  <Col xs={8} md={4} className="px-0">
                  <div className={`newexpandablesearch mx-2  mb-2 ${ this.state.isActive ? "active" : null}`}>
              <div className="searchicon">
                <i
                  onClick={() => {
                    this.setActive();
                  }}
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
              <div className="input">
                <Form.Control
                  type="text"
                  placeholder="search by User Name"
                  className="newsearchinput"
                  onChange={this.onChangeSearch}
                   value={this.state.search}
                  style={{ borderRadius: "28px" }}
                />
                <i className="fa fa-timesw" aria-hidden="true"></i>
              </div>
            </div>
                    {/* <div className="filter-button-search">

                      <Paper component="form" className="enSearch2 d-flex">
                        <IconButton type="submit" aria-label="search">
                          <SearchIcon />
                        </IconButton>
                        <InputBase
                          placeholder="Search"
                          inputProps={{
                            "aria-label": "Search by Name or Phone Number",
                          }}
                          onChange={this.onChangeSearch}
                          value={this.state.search}
                        />
                      </Paper>
                    </div> */}
                    {/* <Form.Control
                      type="text"
                      placeholder="Search"
                      className="amSearch"
                      onChange={(e) => this.setState(e.target.value)}
                    /> */}
                  </Col>
                </Row>
                <div className="row">
                  <div className="col-12">
                    {this.state.selectedTab === 1 ? (
                      <NewOpenIssuesVendorDashboard
                        pageChanger={this.pageChangeButtonHandler}
                        selectedTab={this.state.selectedTab}
                        search={this.state.search}
                      />
                    ) : null || this.state.selectedTab === 2 ? (
                      <InProcessOpenIssuesVendorDashboard
                        pageChanger={this.pageChangeButtonHandler}
                        selectedTab={this.state.selectedTab}
                      />
                    ) : null || this.state.selectedTab === 3 ? (
                      <ClosedOpenIssuesVendorDashboard
                        pageChanger={this.pageChangeButtonHandler}
                        selectedTab={this.state.selectedTab}
                      />
                    ) : null || this.state.selectedTab === 4 ? (
                      <AllOpenIssuesVendorDashboard
                        pageChanger={this.pageChangeButtonHandler}
                        selectedTab={this.state.selectedTab}
                        search={this.state.search}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="right-side-panel"></div> */}
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default OpenIssuesVendor;
